import axios from "axios";
import {
  X_AUTH_TOKEN,
  X_CONTEXT_DEPARTAMENTO,
  getToken,
  getDepartamento,
  logout,
} from "../auth";
import router from "@/router";

let loginRequired = true;

export function withoutLogin() {
  loginRequired = false;
}

const API = axios.create({
  baseURL: "https://api.spalm-ufvjm.conectaa.com.br/", //||process.env.VUE_APP_BASE_URL,
});

API.interceptors.request.use(addAuthHeaders);
API.interceptors.response.use(
  (res) => res,
  (err) => checkAuthError(err)
);

function addAuthHeaders(config) {
  if (config.url && config.url.startsWith("/api/login")) {
    return config;
  }

  const token = getToken();
  if (!token && loginRequired) {
    router.replace("/login");
    return null;
  }

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
    config.headers[X_AUTH_TOKEN] = token;
  }

  const departamento = getDepartamento();
  if (departamento && departamento.id) {
    config.headers[X_CONTEXT_DEPARTAMENTO] = departamento.id;
  }

  return config;
}


function checkAuthError(error) {

  if (error && error.response && error.response.status === 401) {
    logout();
  }

  return Promise.reject(error);
}

export default API;
